export default __webpack_public_path__ + "static/media/sass.95b95881.png";